// ESM twin of backend/src/utils/phone.js cleanPhone, for the browser: strips JobDiva labels such as
// "Work Phone: " and trailing "(C)|" markers. Returns null when no number remains.
export const cleanPhoneValue = (value) => {
  if (value == null) return null;
  const pieces = String(value)
    .split(/[|;\n\r]+/)
    .map(piece => piece
      .replace(/^[^\d+(]*:\s*/, '')
      .replace(/\s*\((?:c|w|h|m|o|f|cell|work|home|mobile|office|fax|main|other)\)\s*$/i, '')
      .replace(/^[\s,]+|[\s,]+$/g, '')
      .trim())
    .filter(piece => /\d/.test(piece));
  return pieces[0] || null;
};

export const getFieldValidationError = (format, value) => {
  const text = String(value ?? '').trim();
  if (!text) return null;
  if (format === 'email') {
    const parts = text.split('@');
    const local = parts[0];
    const domain = parts[1];
    const valid = parts.length === 2 && text.length <= 254 && local.length <= 64
      && /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+$/i.test(local)
      && !local.startsWith('.') && !local.endsWith('.') && !local.includes('..')
      && domain.split('.').length >= 2
      && domain.split('.').every(part => /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i.test(part));
    return valid ? null : 'Enter one valid email address (for example, name@example.com).';
  }
  if (format === 'tel') {
    const number = text.replace(/\s*(?:ext\.?|extension|x|#)\s*\d{1,6}$/i, '').trim();
    const valid = /^(?:\+?1[-.\s]?)?(?:\(\d{3}\)|\d{3})[-.\s]?\d{3}[-.\s]?\d{4}$/.test(number);
    return valid ? null : 'Enter a 10-digit US/Canada phone number, optionally with +1 and an extension (for example, (212) 555-0123 ext. 45).';
  }
  return null;
};

export const getInvalidContactFields = (fields, root) => fields.flatMap(field => {
  const value = String(field.sourcePath || '').replace(/\[(\d+)\]/g, '.$1').split('.')
    .filter(Boolean).reduce((current, key) => current?.[key], root);
  const message = getFieldValidationError(field.format, value);
  return message ? [{
    sourcePath: field.sourcePath,
    label: field.label,
    fieldGroup: field.fieldGroup,
    message
  }] : [];
});
